import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';




@Component({
  selector: 'actia-jsonEditor',
  templateUrl: './jsonEditor.component.html',
  styleUrls: ['./jsonEditor.component.scss']
})
export class ActiaJsonEditorComponent implements OnInit {




  @Input() dataJS:any;

  @Input() idComponent:string | undefined;



  @Input()
  get mode(): any { return this._mode; }
  set mode(value: any) {

    this._mode = value;

    this.jsoneditorOptions.mode = value;
  }
  private _mode:any;

  /** Se true, tutti i nodi sono espansi di default all'apertura. Default false: nessuna regressione per gli usi esistenti. */
  @Input()
  get expandAll(): boolean { return this._expandAll; }
  set expandAll(value: boolean) {

    this._expandAll = value;

    this.jsoneditorOptions.expandAll = value;
  }
  private _expandAll = false;

  @Output() onChangeObject = new EventEmitter()

  jsoneditorOptions = new JsonEditorOptions();

  constructor() {


  }


  ngOnInit(): void {

  }

  changeLog(event:any){

    this.onChangeObject.emit(event)

  }

}
